import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDjLF1o2_P0tt6Bs7Av_8hW8FT95L-ZGl4",
  authDomain: "bioindex-prototype.firebaseapp.com",
  projectId: "bioindex-prototype",
  storageBucket: "bioindex-prototype.firebasestorage.app",
  messagingSenderId: "1049837840725",
  appId: "1:1049837840725:web:df962c66069d8d86dc27dc",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
